//@todo: DOCS pending docs update
const props = {
  editButtonClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$t('item.buttons.edit.class', '')
    }
  },
  editButtonIconClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$t('item.buttons.edit.icon.class', 'fa fa-pencil')
    }
  },
  editButtonTitle: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$t('item.buttons.edit.title', 'Edit')
    }
  },
  deleteButtonClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$t('item.buttons.delete.class', '')
    }
  },
  deleteButtonIconClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$t('item.buttons.delete.icon.class', 'fa fa-times')
    }
  },
  topButtonsClasses: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('item.product.imageClass', 'mobile')
    }
  },
  bottomButtonsClasses: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('item.product.imageClass', 'non-mobile')
    }
  },
  showTopButtonTitles: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('item.buttons.top.showTitle', false)
    }
  },
  showBottomButtonTitles: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('item.buttons.bottom.showTitle', false)
    }
  },
  showTopButtonIcons: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('item.buttons.top.showIcon', true)
    }
  },
  showBottomButtonIcons: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('item.buttons.bottom.showIcon', true)
    }
  },

}


export default props
